import { useEffect, useState } from "react";
import { Loader2, Scale } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";

export default function Legal() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/legal").then((r) => setD(r.data)).catch(() => setD({ contenu: "" })); }, []);
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-14 lg:py-20">
      <div className="flex items-center gap-2 text-xs uppercase tracking-[0.14em] text-emerald-700 font-semibold"><Scale className="h-4 w-4" /> Cadre juridique</div>
      <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">Mention légale</h1>
      {d === null ? <Loader2 className="mt-10 h-8 w-8 animate-spin text-emerald-700" /> : d.contenu ? (
        <>
          {d.updated_at && <p className="mt-3 text-sm text-slate-500">Mis à jour le {fmtDate(d.updated_at)}</p>}
          <div data-testid="legal-content" className="mt-10 rounded-2xl border border-emerald-900/10 bg-white p-6 sm:p-10 text-slate-700 leading-relaxed whitespace-pre-line">{d.contenu}</div>
        </>
      ) : <p data-testid="legal-empty" className="mt-10 text-slate-500">Le texte de l'ordonnance-loi portant création de l'UAPHARCO sera publié prochainement.</p>}
    </article>
  );
}
